import { Card, Flex, Label, Loader, Modal } from '@fareye/ui'
import {
  cancelToken,
  get,
  MdBookmark,
  MdBookmarkBorder,
  MdShare,
  MdTextsms,
  post
} from '@fareye/utils'
import React from 'react'
import { BreadcrumbItem, HeaderFrame } from '../../../style/styled'
import Logo from '../../../utility/fareye-logo.json'
import CopyText from '../../../components/CopyText'
import { useTranslation } from '@fareye/common'

const initShare = {
  data: [],
  isLoading: false,
  isSuccess: false,
  isError: false,
  message: ''
}

export default function({
  slug,
  config,
  setIssueClicked,
  breadcrumbText,
  issuesCount = 0
}: any) {
  const { t } = useTranslation()
  const [subscribe, setSubscribe] = React.useState(false)
  const [share, setShare] = React.useState(initShare)
  const [link, setLink] = React.useState<string | null>(null)
  const source = cancelToken().source()
  const {
    shareURL,
    subscribeURL,
    shareQueryParams,
    linkURL,
    showIssueRaised = false
  } = config
  async function fetchMarkData() {
    try {
      const {
        data: { message, success }
      } = await get(`${subscribeURL}${slug}`, source.token)
      setSubscribe(success)
      alert(
        `Success!!, Trip ${
          success ? 'Subscribed' : 'Unsubscribed'
        } Successfully`
      )
    } catch (error) {
      console.error('App Error:', error)
    }
  }

  async function fetchShareSlug() {
    setShare({ ...share, isLoading: true })
    try {
      let payload = {
        ...shareQueryParams,
        resource_id: slug
      }
      const { data } = await post(shareURL, payload, source.token)
      if (data) {
        const link = `${linkURL}/${data.content}`
        setShare({ ...share, isLoading: false })
        setLink(link)
      }
    } catch (error) {
      setShare({ ...share, isLoading: false })
      console.error('App Error:', error)
    }
  }
  const shareIsLoading: boolean = shareURL && share.isLoading //&& !shareExpired
  const showShare: boolean = shareURL //&& !shareExpired

  return (
    <HeaderFrame alignItemsCenter justifyContentSpaceBetween>
      {showShare && (
        <BreadcrumbItem
          variant={`s primary link`}
          disabled
          style={{ background: 'transparent' }}
        >
          {t(breadcrumbText) || t('Trips')}
        </BreadcrumbItem>
      )}
      {!showShare && (
        <img
          src={Logo.logo}
          alt="fareye-logo"
          style={{
            margin: '0 auto',
            height: 'auto',
            width: '15vmax'
          }}
        />
      )}

      <Flex>
        {shareIsLoading && <Loader size={24} />}
        {showShare && (
          <Label
            style={{
              cursor: 'pointer',
              marginLeft: '12px',
              color: '#217CE7'
            }}
            onClick={() => fetchShareSlug()}
          >
            <MdShare style={{ marginBottom: '-2px' }} />
            {` ${t('Share')}`}
          </Label>
        )}
        {subscribeURL && false && (
          <Label
            style={{ cursor: 'pointer', marginLeft: '12px', color: '#217CE7' }}
            onClick={() => fetchMarkData()}
          >
            {subscribe ? (
              <MdBookmark style={{ marginBottom: '-2px', color: 'yellow' }} />
            ) : (
              <MdBookmarkBorder style={{ marginBottom: '-2px' }} />
            )}
            {`${subscribe ? t('Unmark') : t('Mark')} ${t('Important')}`}
          </Label>
        )}
        {showIssueRaised && (
          <Label
            style={{ cursor: 'pointer', marginLeft: '12px', color: '#217CE7' }}
            onClick={() => setIssueClicked(true)}
          >
            <MdTextsms style={{ marginBottom: '-2px', marginRight: 5 }} />
            {`${t('Issues Raised')} (${issuesCount})`}
          </Label>
        )}
      </Flex>
      {link && (
        <Modal
          variant="xxs"
          toggleModal={Boolean(link)}
          setToggleModal={() => setLink(null)}
        >
          <Card variant="xs" header={t('Share Trip Link')}>
            <CopyText link={link} />
          </Card>
        </Modal>
      )}
    </HeaderFrame>
  )
}
